import { BillPayEntryPoint } from '../use-payment-flow';

const validBillPayEntryPoints: readonly BillPayEntryPoint[] = [
  'BILL_PAY_UPLOAD_INVOICE',
  'VIEW_ALL_BENEFICIARIES',
  'INVOICE_PAGE',
];

export const isBillPayEntryPoint = (value: string | null): value is BillPayEntryPoint => {
  if (value === null) {
    return false;
  }

  return validBillPayEntryPoints.includes(value as BillPayEntryPoint);
};
